/* eslint-disable camelcase */
const AgilityNomadic = ({ databoxes: { percent_nomadic } }) =>
  `${percent_nomadic}% of users were in less than 20% of the
   time during the study period and can usually be considered nomadic in
   their use of this and other locations.`;

export default AgilityNomadic;
